import React from 'react';
import { TicketIcon } from '@heroicons/react/24/outline';

const TicketsPage = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-3">
        <TicketIcon className="h-8 w-8 text-blue-600" />
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Tickets</h1>
          <p className="text-gray-600">View and manage weighing tickets</p>
        </div>
      </div>
      
      <div className="card">
        <p className="text-gray-500">Tickets management interface - Coming soon</p>
      </div>
    </div>
  );
};

export default TicketsPage;